import { AnyAction } from 'redux';
import { OakyResult, ResourceState } from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { updateResourcesState } from '@mews-commander/legacy-entities/src/actions/resources';
import { checkIn, getReservationsCustomerIds } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { getCurrentEnterpriseReservationAssignedResourceId } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { prefix } from '../../module';
import { fetchCustomerBalances } from '../../ducks/balances';

export const OAKY_UPSELL_URL_FETCH = prefix('OAKY_UPSELL_URL_FETCH');

interface SetInspectedAndCheckInProps {
    reservationId: string;
    disablePreauthorization?: boolean;
    makeResourceInspected?: boolean;
}

export const setInspectedAndCheckIn =
    ({
        reservationId,
        disablePreauthorization,
        makeResourceInspected,
    }: SetInspectedAndCheckInProps): CommanderThunkAction<AnyAction, Promise<unknown>> =>
    async (dispatch, getState) => {
        if (makeResourceInspected) {
            const assignedResourceId = getCurrentEnterpriseReservationAssignedResourceId(getState(), {
                id: reservationId,
            });
            await dispatch(
                updateResourcesState({
                    resourceIds: [assignedResourceId],
                    state: ResourceState.Inspected,
                    stateReason: null,
                })
            );
        }
        return dispatch(checkIn([reservationId], disablePreauthorization));
    };

export const fetchReservationBalance =
    (reservationId: string): CommanderThunkAction =>
    async (dispatch, getState) => {
        const state = getState();
        const enterpriseId = getCurrentEnterpriseId();
        const customerIds = getReservationsCustomerIds(state, { ids: [reservationId], enterpriseId });
        return dispatch(fetchCustomerBalances(customerIds, enterpriseId));
    };
export const fetchCustomerBalance =
    (customerId: string): CommanderThunkAction =>
    async (dispatch) => {
        const enterpriseId = getCurrentEnterpriseId();
        return dispatch(fetchCustomerBalances([customerId], enterpriseId));
    };

export const fetchOakyUpsellUrl =
    (reservationId: string): CommanderThunkAction<AsyncAction<OakyResult>> =>
    async (dispatch, getState, { repositories, loggerService }) => {
        const enterpriseId = getCurrentEnterpriseId();
        const promise = repositories.oaky
            .getUrl({
                reservationId,
                enterpriseId,
            })
            .catch(() => {
                loggerService.log('oaky', 'Oaky URL failed to fetch', { reservationId, enterpriseId });

                return { url: null };
            });

        return dispatch(createFetchAction(OAKY_UPSELL_URL_FETCH, promise));
    };
